export default "__VITE_ASSET__BzmdaJcH__"